export default __webpack_public_path__ + "static/media/Rectangle3.39ffa106.jpg";